import { UXCustomizationType } from "@gtmhub/uxcustomization/models";
import { NavigationItemsFacade } from "@gtmhub/uxcustomization/navigation-items-facade";
import { INavItem, uxcToNavItemsMap } from "@webapp/navigation/models/nav-items-list.models";

export class FavoritesManager {
  public static $inject = ["NavigationItemsFacade"];
  private entityTypes: UXCustomizationType[];

  constructor(private navigationItemsFacade: NavigationItemsFacade, entityTypes: UXCustomizationType[]) {
    this.entityTypes = entityTypes;
  }

  public initFavorites() {
    this.navigationItemsFacade.setupEntityTypes(this.entityTypes, uxcToNavItemsMap[this.entityTypes[0]]);
    this.navigationItemsFacade.setupFavorites();
  }

  public entityIsFavorite = (entity: { id: string }): boolean => {
    const favorite = this.navigationItemsFacade.getFavoriteItems().items.find((favItem) => favItem.id === entity.id);
    return !!favorite;
  };

  public getFavoriteItem = (entity: { id: string }): INavItem => {
    return this.navigationItemsFacade.getFavoriteItems().items.find((favItem) => favItem.id === entity.id);
  };

  public addToFavorites = (entity: { id: string }, type: UXCustomizationType, navItem: INavItem) => {
    this.navigationItemsFacade.markItemAsFavorite(entity.id, type, navItem);
  };

  public removeFromFavorites = (entity: { id: string }, navItem: INavItem) => {
    const existingNavItem = this.navigationItemsFacade.getFavoriteItems().items.find((favoriteItem) => favoriteItem.id === entity.id);
    this.navigationItemsFacade.unmarkItemAsFavorite(existingNavItem.favoriteId, navItem);
  };
}
